import { UPDATE_SEARCH_RESULTS } from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
  case UPDATE_SEARCH_RESULTS: {
    const searchResults = action.payload;
    return searchResults;
  }
  }
  return state;
}
